import React, { useEffect, useRef, useState } from "react";
import ChangePass from "./ChangePass";
import { useForm } from "react-hook-form";
import ImageControl from "../../common/ImageControl";
import * as paths from "../../../constants/paths";
import DeleteAccount from "./DeleteAccount";
import { toast } from "react-toastify";
import { TOAST_SETTINGS } from "../../../utils/siteSettings";
import Breadcrumb from "../../common/BreadCrumb";

const Settings = ({
  data,
  mem,
  mem_subscribed,
  isFormProcessing,
  saveProfileSettings,
  changePassword,
  isPassChangeProcessing,
}) => {

  const breadcrumbItems = [
    { name: "Dashboard", link: "/dashboard" },
    { name: "Account Settings", link: "/profile-settings" },
  ];
  const [previewImage, setPreviewImage] = useState(null);
  const [image, setImage] = useState(null);
  const profilePicRef = useRef(null);

  const {
    register,
    watch,
    formState: { errors },
    handleSubmit,
  } = useForm();

  const { personal_info, change_pass } = data;

  const onSubmit = (data) => {
    if (image !== null) data.profile = image.target.files;
    saveProfileSettings(data);
  };

  const handlePhotoSelect = (e) => {
    e.preventDefault();
    profilePicRef.current.click();
  };

  const handleProfilePicChange = (e) => {
    e.preventDefault();
    if (e.target.files && e.target.files[0]) {
      setImage(e);
      setPreviewImage(URL.createObjectURL(e.target.files[0]));
    }
  };

  const [showPopup, setShowPopup] = useState(false);
  const [step, setStep] = useState(0); // 0: nothing, 1: sub warning, 2: reason form
  const [isDeleteChecked, setIsDeleteChecked] = useState(false);

  const handleDelete = () => {
    setShowPopup(false);
    setStep(0);
  };

  const handleDeleteClick = () => {
    if (!isDeleteChecked) {
      toast.error(
        "Please check the box first. Only then you will be able to delete the account.",
        TOAST_SETTINGS
      );
      return;
    }

    if (mem_subscribed !== null) {
      setStep(1); // show sub warning first
    } else {
      setStep(2); // go directly to reason form
    }
    setShowPopup(true);
  };

  const handleSubConfirm = () => {
    setStep(2); // move to reason form
  };

  const handleCancel = () => {
    setShowPopup(false);
    setStep(0);
  };

  return (
    <>
      <section id="settings">
        <Breadcrumb items={breadcrumbItems} />
        <div className="contain">
          <form action="" method="POST" onSubmit={handleSubmit(onSubmit)}>
            <h4 className="heading">{personal_info.heading}</h4>
            <div className="dp_blk upLoadDp">
              <div className="ico fill round">
                {previewImage != null ? (
                  <img src={previewImage} alt="Preview" />
                ) : mem.mem_image == null || mem.mem_image === "" ? (
                  <img
                    src={paths.SITE_BASE_URL + "/images/new/frame.svg"}
                    alt="No Image"
                  />
                ) : (
                  <ImageControl
                    src={mem.mem_image}
                    folder="members"
                    alt="Profile Image"
                    isThumb={true}
                  />
                )}
              </div>
              <div className="txt">
                <div className="upload_btn_blk">
                  <div className="mini_image">
                    <img
                      src={paths.SITE_BASE_URL + "/images/new/upload.svg"}
                      alt="Upload"
                    />
                  </div>
                  <span className="color" onClick={handlePhotoSelect}>
                    Upload new
                  </span>
                  <input
                    type="file"
                    id="profile"
                    {...register("profile")}
                    onChange={handleProfilePicChange}
                    ref={profilePicRef}
                    hidden
                  />
                </div>
              </div>
            </div>

            <div className="br"></div>
            <h4 className="heading">Basic Information</h4>
            <div className="form_row row">
              <div className="col-sm-6 col-xs-6">
                <h5>First Name</h5>
                <div className="form_blk">
                  <input
                    defaultValue={mem.mem_fname}
                    type="text"
                    className="input"
                    {...register("fname", {
                      required: "First Name is required.",
                      maxLength: {
                        value: 20,
                        message:
                          "First Name should Not be greater than 20 characters.",
                      },
                      minLength: {
                        value: 2,
                        message:
                          "First Name should be greater than atleast 2 characters.",
                      },
                    })}
                  />
                  <span className="validation-error">
                    {errors.fname?.message}
                  </span>
                </div>
              </div>

              <div className="col-sm-6 col-xs-6">
                <h5>Last Name</h5>
                <div className="form_blk">
                  <input
                    defaultValue={mem.mem_lname}
                    type="text"
                    className="input"
                    {...register("lname", {
                      required: "Last Name is required.",
                      maxLength: {
                        value: 20,
                        message:
                          "Last Name should Not be greater than 20 characters.",
                      },
                      minLength: {
                        value: 2,
                        message:
                          "Last Name should be greater than atleast 2 characters.",
                      },
                    })}
                  />
                  <span className="validation-error">
                    {errors.lname?.message}
                  </span>
                </div>
              </div>

              <div className="col-sm-6 col-xs-6">
                <h5>Phone Number</h5>
                <div className="form_blk">
                  <input
                    defaultValue={mem.mem_phone}
                    type="text"
                    className="input"
                    {...register("phone", {
                      required: "Phone number is required.",
                    })}
                  />
                  <span className="validation-error">
                    {errors.phone?.message}
                  </span>
                </div>
              </div>

              <div className="col-sm-6 col-xs-6">
                <h5>Email Address</h5>
                <div className="form_blk">
                  <input
                    defaultValue={mem.mem_email}
                    type="text"
                    readOnly
                    className="input"
                  />
                </div>
              </div>
            </div>

            <div className="btn_blk form_btn">
              <button
                type="submit"
                className="site_btn lg long"
                disabled={isFormProcessing}
              >
                Update Information
              </button>
            </div>
          </form>

          <div className="br"></div>
          <div className="br"></div>

          <ChangePass
            val={change_pass}
            changePassword={changePassword}
            isPassChangeProcessing={isPassChangeProcessing}
          />

          <div className="br"></div>

          <div className="del_account_opt">
            <div className="left_text_dell">
              <h4 className="heading">Delete Account</h4>
              <p>Delete your account and all the data</p>
            </div>
          </div>

          <div className="lbl_btn">
            <input
              type="checkbox"
              id="delete_confirm"
              checked={isDeleteChecked}
              onChange={(e) => setIsDeleteChecked(e.target.checked)}
            />
            <label htmlFor="delete_confirm">
              I can confirm that I do not have a paid subscription or I have
              already cancelled my paid subscription.
            </label>
          </div>
          <div className="cta">
            <div className="btn_blk">
              <button
                type="button"
                className="site_btn blank"
                onClick={handleDeleteClick}
                disabled={mem_subscribed !== null}
              >
                Delete Account
              </button>
            </div>
          </div>
        </div>
      </section>

      {showPopup && (
        <DeleteAccount
          showPopup={true}
          onConfirm={step === 1 ? handleSubConfirm : handleDelete}
          onCancel={handleCancel}
          mem_subscribed={step === 1 ? "sub-warning-flow" : null}
        />
      )}
    </>
  );
};

export default Settings;
